<template>
  <div v-if="selectedMasterClass && isOpen">
    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-buy" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  Waiting Time ({{ selectedMasterClass.masterClassName }})
                </h4>
                <h6 v-if="timestampItem">Last Updated: {{ timestampItem }}</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div class="col-sm-3 divider-right pr-25">
                        <div class="form-group">
                          <label class="required">Source Type</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.type.$error,
                            }"
                            label="text"
                            v-model="model.type"
                            :options="sourceTypes"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.value"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.type.required"
                          >
                            Type is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Zones</label>
                          <multiselect
                            v-model="model.zones"
                            :class="{
                              'field-error':
                                isSubmitted && !$v.model.zones.required,
                            }"
                            :options="zones"
                            :multiple="true"
                            :close-on-select="false"
                            placeholder="Select zones"
                            label="label"
                            track-by="id"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.zones.required"
                          >
                            Zone(s) is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Allowed Time <span class="--grey50">(minute)</span>
                          </label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.totalMinuteAllowed.$error,
                            }"
                            type="number"
                            v-model="model.totalMinuteAllowed"
                          />
                          <div
                            v-if="
                              isSubmitted && $v.model.totalMinuteAllowed.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalMinuteAllowed.required"
                            >
                              Total minutes allowed is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalMinuteAllowed.minValue"
                            >
                              Min total minutes is
                              {{
                                $v.model.totalMinuteAllowed.$params.minValue.min
                              }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Interval <span class="--grey50">(minute)</span>
                          </label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.gracePriodInterval.$error,
                            }"
                            type="number"
                            v-model="model.gracePriodInterval"
                          />
                          <div
                            v-if="
                              isSubmitted && $v.model.gracePriodInterval.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.gracePriodInterval.required"
                            >
                              Interval is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.gracePriodInterval.minValue"
                            >
                              Min interval is
                              {{
                                $v.model.gracePriodInterval.$params.minValue.min
                              }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Currency</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && !$v.model.currency.required,
                            }"
                            placeholder="Select currency"
                            label="text"
                            v-model="model.currency"
                            :options="currencies"
                            :clearable="false"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.value"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.currency.required"
                          >
                            Currency is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Rate</label>
                          <currency-input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.rate.$error,
                            }"
                            autocomplete="off"
                            placeholder="Enter rate"
                            v-model="model.rate"
                            :allow-negative="false"
                            :currency="null"
                            :locale="moneyFormat.cultureCode"
                            :precision="moneyFormat.numberOfDecimal"
                          />
                          <div v-if="isSubmitted && $v.model.rate.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.required"
                            >
                              Rate is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.minValue"
                            >
                              Min rate is
                              {{ $v.model.rate.$params.minValue.min }}
                            </small>
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="onResetForm()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="onSubmitForm()"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="onSubmitForm()"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div class="col-sm-9 divider-left pl-20">
                        <div class="table-modal-detail">
                          <div class="table-responsive table-accordion">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Source</th>
                                  <th>Pick-up Zones</th>
                                  <th class="text-center">
                                    Allowed Time (minute)
                                  </th>
                                  <th class="text-right">Interval (minute)</th>
                                  <th class="text-right">Rate</th>
                                  <th class="text-center">Status</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in items"
                                  :key="item.id"
                                >
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td>
                                    {{
                                      $helper.printWaitingTimeSourceType(
                                        item.type
                                      )
                                    }}
                                  </td>
                                  <td>
                                    <template
                                      v-if="item.zones && item.zones.length > 0"
                                    >
                                      <p
                                        v-for="(
                                          zone, idxZoneItem
                                        ) in item.zones"
                                        :key="idxZoneItem"
                                      >
                                        <span class="text-muted">{{
                                          zone.group
                                        }}</span>
                                        {{ zone.name }}
                                      </p>
                                    </template>
                                    <template v-else> - </template>
                                  </td>
                                  <td class="text-center">
                                    {{ item.totalMinuteAllowed }}
                                  </td>
                                  <td class="text-center">
                                    {{ item.gracePriodInterval }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.currency }}
                                    {{ printMoney(item.rate) }}
                                  </td>
                                  <td class="text-center">
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="onChangeStatus(item)"
                                      />
                                      <span
                                        class="pl-5 font-weight-normal v-align-middle"
                                      >
                                        {{
                                          item.isActive ? "Active" : "Inactive"
                                        }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div class="button-action-wrapper">
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-default"
                                        type="button"
                                        @click="onEdit(item)"
                                      >
                                        <span>Edit</span>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-default"
                                        type="button"
                                        @click="onDelete(item)"
                                      >
                                        <i class="ic-close"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffWaitingTimeSurchargeService from "@/services/master/buyingTariff/buyingTariffWaitingTimeSurchargeService.js";
import { WaitingTimeType } from "@/models/constants";

const defaultModel = {
  id: null,
  masterClassId: null,
  type: null,
  totalMinuteAllowed: null,
  gracePriodInterval: null,
  rate: null,
  currency: null,
  isActive: true,
  zones: [],
};

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      isOpen: false,
      rentalLabel: null,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedMasterClass: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      sourceTypes: WaitingTimeType,
      items: [],
      currencies: [],
      zones: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        totalMinuteAllowed: { required, minValue: minValue(0) },
        gracePriodInterval: { required, minValue: minValue(0) },
        currency: { required, maxLength: maxLength(3) },
        rate: { required, minValue: minValue(0) },
        zones: { required },
      },
    };
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    this.$eventBus.$on(
      "initializeBuyingTariffWaitingTimeSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffWaitingTimeSurcharge");
  },
  methods: {
    async initialize(masterClass, moneyFormat, formatter, currencies, zones) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedMasterClass = masterClass;
        this.moneyFormat = moneyFormat;
        this.formatter = formatter;
        this.currencies = currencies;
        this.zones = zones;

        // this.sourceTypes = [
        //   { text: "Airport Transfer (Arrival)", value: "ArrivalAirportTransfer" },
        //   {
        //     text: "Airport Transfer (Departure)",
        //     value: "DepartureAirportTransfer",
        //   },
        //   { text: "In-Town Transfer", value: "InTownTransfer" },
        //   {
        //     text: this.rentalLabel,
        //     value: "Rental",
        //   },
        // ];

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions =
          profile.services["BuyingTariffWaitingTimeSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.getAll().then(() => {
            $(this.$refs.vuemodal).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.onResetForm();
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
    printMoney(value) {
      return this.formatter !== null
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = Object.assign({}, defaultModel);
    },
    clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.type = item.type;
      this.model.totalMinuteAllowed = item.totalMinuteAllowed;
      this.model.gracePriodInterval = item.gracePriodInterval;
      this.model.rate = item.rate;
      this.model.currency = item.currency;
      this.model.isActive = item.isActive;
      this.model.zones = this.zones.filter((array) =>
        item.zones.some((filter) => filter.id === array.id)
      );
    },
    constructPayload() {
      const payload = Object.assign({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.type = this.model.type;
      payload.totalMinuteAllowed = this.model.totalMinuteAllowed;
      payload.gracePriodInterval = this.model.gracePriodInterval;
      payload.rate = this.model.rate;
      payload.currency = this.model.currency;
      payload.zones = this.model.zones.map((zone) => zone.id);

      return payload;
    },
    async getAll() {
      this.items = await buyingTariffWaitingTimeSurchargeService.getAll(
        this.selectedMasterClass.masterClassId
      );
    },
    async onChangeStatus(item) {
      this.isLoading = true;
      this.isUpdate = true;
      this.bindModel(item);
      this.model.isActive = !!this.model.isActive;

      try {
        const payload = this.constructPayload();
        await this.submitUpdate(payload);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmitForm() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;
        const payload = this.constructPayload();
        if (this.isUpdate) {
          await this.submitUpdate(payload);
        } else {
          await this.submitCreate(payload);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submitCreate(payload) {
      await buyingTariffWaitingTimeSurchargeService.create(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully created.", {
          title: "Success",
        });
      });
    },
    async submitUpdate(payload) {
      await buyingTariffWaitingTimeSurchargeService.update(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
      });
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffWaitingTimeSurchargeService.delete(
          this.itemIdToBeDeleted
        );
        this.itemIdToBeDeleted = null;

        this.getAll().then(() => {
          this.$notification.success("Successfully deleted.", {
            title: "Success",
          });
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/WaitingTimeSurcharge.vue